export interface IWindowOptions {
  token: string;
  refreshToken: string;
  eventType: string;
  oauthType: string;
  id: string;
  meta: { [key: string]: any };
  merchId?: string,
  stringLoginMerchantForReLogin?: string
}

export enum EventType {
  RefreshTokenError = "RefreshTokenError",
  Init = "Init",
  RefreshTokenSuccess = "RefreshTokenSuccess",
  TakePhoto = "takePhoto",
  PC = "PC",
  WXApplicationDidBecomeActiveEvent = "WXApplicationDidBecomeActiveEvent",
  onBackPress = "onBackPress",
  AzurePushEntity = "registerAzurePush",
  toOrderPage = "toOrderPage"
}
